
//open footer menu
document.addEventListener("DOMContentLoaded", function() {
  // Function to open accordion by ID
  function openAccordion(accordionId) {
    var collapsibleTrigger = document.querySelector('.collapsible-trigger-btn[aria-controls="' + accordionId + '"]');

    // Check if the accordion is closed
    if (collapsibleTrigger && collapsibleTrigger.getAttribute('aria-expanded') === 'false') {
      // Set aria-expanded to true
      collapsibleTrigger.setAttribute('aria-expanded', 'true');

      // Add the is-open class to the button
      collapsibleTrigger.classList.add('is-open');

      // Find the associated collapsible content and open it
      var content = document.getElementById(accordionId);
      if (content) {
        content.classList.add('is-open');
        content.style.height = 'auto';
      }
    }
  }

  // Open specific accordions
  openAccordion('Footer-menu_hkrmdw');
  openAccordion('Footer-footer-1');
  openAccordion('Footer-footer2');
  
});

/* Product carousel (Pro) – Splide init + плавен wheel, „peek“ с padding */
(() => {
  const SECTION_SEL = '[data-fc-splide]';

  // по-плавна анимация
  const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

  function smoothScrollTo(elem, target, duration = 420){
    const max = elem.scrollWidth - elem.clientWidth;
    target = Math.max(0, Math.min(max, target));
    if (elem._fcRaf) cancelAnimationFrame(elem._fcRaf);

    const start = elem.scrollLeft;
    const dist  = target - start;
    if (Math.abs(dist) < 1){ elem.scrollLeft = target; return; }

    const t0 = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - t0) / duration);
      elem.scrollLeft = start + dist * easeOutCubic(t);
      if (t < 1) elem._fcRaf = requestAnimationFrame(tick);
      else elem._fcRaf = null;
    };
    elem._fcRaf = requestAnimationFrame(tick);
  }

  function init(root){
    (root || document).querySelectorAll(SECTION_SEL).forEach(el => {
      if (el._splide || !window.Splide) return;

      // четем настройките от data-атрибути (идват от секцията)
      const perPageD = parseFloat(el.dataset.perpage)        || 4.2;   // дробно → „peek“
      const perPageM = parseFloat(el.dataset.perpageMobile)  || 1.15;
      const gap      = (parseInt(el.dataset.gap) || 16) + 'px';
      const arrows   = el.dataset.arrows === 'true';
      const dots     = el.dataset.pagination === 'true';
      const autoplay = el.dataset.autoplay === 'true';
      const interval = parseInt(el.dataset.interval) || 4000;
      const loop     = el.dataset.loop === 'true';
      const edgeD    = (parseInt(el.dataset.edgeDesktop) || 32) + 'px';
      const edgeM    = (parseInt(el.dataset.edgeMobile)  || 16) + 'px';

      const splide = new Splide(el, {
        type: loop ? 'loop' : 'slide',
        perPage: perPageD,
        perMove: 1,
        gap,
        arrows,
        pagination: dots,
        autoplay,
        interval,
        pauseOnHover: true,
        pauseOnFocus: true,
        drag: 'free',
        flickPower: 600,
        speed: 520,
        easing: 'cubic-bezier(.2,.8,.2,1)',
        trimSpace: false,
        focus: 'left',
        padding: { left: edgeD, right: edgeD },
        breakpoints: {
          989: { perPage: perPageM, padding: { left: edgeM, right: edgeM }, gap }
        }
      });

      // Плавен wheel, но НЕ блокирай вертикален скрол и пускай на край/начало
      splide.on('mounted', () => {
        const track = el.querySelector('.splide__track');
        const list  = el.querySelector('.splide__list');
        if (!track || !list) return;

        let targetLeft = 0, animating = false;
        track.addEventListener('wheel', (e) => {
          const horiz = Math.abs(e.deltaX);
          const vert  = Math.abs(e.deltaY);
          const intendedHorizontal = e.shiftKey || (horiz > vert * 1.2);

          if (!intendedHorizontal) return; // остави страницата да се скролира

          // посока – ползвай доминиращия компонент
          let dx = horiz >= vert ? e.deltaX : e.deltaY;

          const atStart = list.scrollLeft <= 1;
          const atEnd   = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
          if ((dx < 0 && atStart) || (dx > 0 && atEnd)) return; // пусни към страницата

          e.preventDefault();
          const max = list.scrollWidth - list.clientWidth;
          targetLeft = Math.max(0, Math.min(max, (animating ? targetLeft : list.scrollLeft) + dx));
          animating = true;
          smoothScrollTo(list, targetLeft, 420);
          setTimeout(() => { animating = false; }, 450);
        }, { passive: false });
      });

      splide.mount();
      el._splide = splide;
    });
  }

  // стартирай
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  // при промени в редактора
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

/* Product carousel (Pro) – END */
